var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spa-status-message container" }, [
    _c(
      "div",
      {
        staticClass: "spa-status-message-wrapper",
        class: "--" + _vm.type,
        attrs: { role: "status" },
      },
      [
        _vm.icon
          ? _c("span", {
              class: "icon-" + _vm.icon,
              attrs: { "aria-hidden": "true" },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.message))]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }